<script>
  import logo from "../img/logo.svg";
  import { fade } from "svelte/transition";
</script>

<style>
  .loader {
    position: fixed;
    z-index: 999;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .logoContainer {
    width: 100%;
    max-width: 400px;
    padding: 1rem;
    margin-left: auto;
    margin-right: auto;
  }
  
</style>

<div
  transition:fade={{ delay: 1000 }}
  class="loader bg-secondary d-flex flex-column align-items-center justify-content-center">
  <div class="logoContainer"><img src={logo} alt="openpod logo" /></div>
  <div
    class="spinner-border text-primary mt-3"
    style="width: 3rem; height: 3rem;"
    role="status">
    <span class="sr-only">Carico...</span>
  </div>
</div>
